<div class="card card-form">

  <ng-container *ngIf="formView.cnh || formView.crlv || formView.documento || formView.veiculo|| formView.renavam || formView.placaRenavam">
    <h2 class="w-100 p-2 modal-header">Formulário - consultas veiculares</h2>

      <div *ngIf="formView.veiculo || formView.placa" class="col-lg-8 col-xl-4 flex-grow p-1">
        <div class="rounded bg-light px-md-2 p-1 form-item">
          <div class="d-flex mb-1">
            <app-input-radio size="md" [(model)]="formView.tipoPesquisaVeiculo" [disabled]="disabledVeiculoOptions.placa" (modelChange)="setControlVeiculo()"
              value="placa" label="Placa" class="mr-4">
            </app-input-radio>
            <app-input-radio size="md" [(model)]="formView.tipoPesquisaVeiculo" [disabled]="disabledVeiculoOptions.chassi" (modelChange)="setControlVeiculo()"
              value="chassi" label="Chassi" class="mr-4">
            </app-input-radio>
            <!-- <app-input-radio size="md" [(model)]="formView.tipoPesquisaVeiculo" [disabled]="disabledVeiculoOptions.motor" (modelChange)="setControlVeiculo()"
              value="motor" label="Motor" class="mr-4">
            </app-input-radio> -->
          </div>
          <div class="w-100">
            <input *ngIf="formView.tipoPesquisaVeiculo=='placa'" placeholder="Informe a placa do veículo"
              [textMask]="masks.placa" type="text" [formControl]="form.controls.veiculo"
              class="form-control input-validate text-uppercase">
            <input *ngIf="formView.tipoPesquisaVeiculo=='chassi'" placeholder="Informe o chassi do veículo" type="text"
              [formControl]="form.controls.veiculo" class="form-control input-validate text-uppercase">
            <input *ngIf="formView.tipoPesquisaVeiculo=='motor'" placeholder="Informe o número do veículo" type="text"
              [formControl]="form.controls.veiculo" class="form-control input-validate text-uppercase">
          </div>
          <app-msg-erro [control]="form.controls.veiculo" sempreExibir="true"></app-msg-erro>
        </div>
      </div>


    <div *ngIf="formView.cnh" class="col col-lg-4 p-1">
      <div class="rounded p-1 px-md-2 bg-light form-item">
        <div class="d-flex mb-1">
          <app-input-radio size="md" [(model)]="formView.tipoPesquisaCnh" (modelChange)="setControlCnh()" value="cnh"
            label="CNH" class="mr-4">
          </app-input-radio>
          <app-input-radio size="md" [(model)]="formView.tipoPesquisaCnh" (modelChange)="setControlCnh()" value="cpf"
            label="CPF">
          </app-input-radio>
        </div>

        <ng-container *ngIf="formView.tipoPesquisaCnh=='cnh'">
          <input placeholder="Digite o número da CNH" type="text" [formControl]="form.controls.cnh"
            class="form-control input-validate">
          <app-msg-erro [control]="form.controls.cnh" sempreExibir="true"></app-msg-erro>
        </ng-container>

        <ng-container *ngIf="formView.tipoPesquisaCnh=='cpf'">
          <input placeholder="Digite o número do CPF" type="text" [formControl]="form.controls.cnh_cpf"
            [textMask]="masks.cpf" class="form-control input-validate">
          <app-msg-erro [control]="form.controls.cnh_cpf" sempreExibir="true"></app-msg-erro>
        </ng-container>
      </div>
    </div>

    <div *ngIf="formView.renavam" class="col-lg-4 p-1">
      <div class="rounded p-1 px-md-2 bg-light form-item">
        <label for="documento">
          Digite o renavam
        </label>
        <input [textMask]="masks.renavam" type="text" [formControl]="form.controls.renavam"
          class="form-control input-validate">
        <app-msg-erro [control]="form.controls.renavam" sempreExibir="true"></app-msg-erro>
      </div>
    </div>

    <div *ngIf="formView.documento" class="col-lg-4 p-1">
      <div class="rounded p-1 px-md-2 bg-light form-item">
        <label for="documento">
          Digite o documento (CPF ou CNPJ)
        </label>
        <input [textMask]="masks.documento" type="text" [formControl]="form.controls.documento"
          class="form-control input-validate">
        <app-msg-erro [control]="form.controls.documento" sempreExibir="true"></app-msg-erro>
      </div>
    </div>

    <div *ngIf="formView.crlv" class="col-lg-4 p-1 p-md-2">
      <div class="rounded p-1 px-md-2 form-item bg-light">
        <label for="pesquisaVeiculo">
          Digite o CRLV
        </label>
        <input type="text" [formControl]="form.controls.crlv" class="form-control input-validate">
        <app-msg-erro [control]="form.controls.crlv" sempreExibir="true"></app-msg-erro>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="formView.cpf || formView.cnpj || formView.uf">

    <h2 class="w-100 p-2 mt-2 modal-header">Formulário - consultas créditos</h2>

      <div class="col-12 col-lg-4 p-1" *ngIf="formView.cpf">
        <div class="px-2 pt-2 bg-light rounded">
          <label for="">CPF</label>
          <input type="text" [formControl]="form.controls.cpf" [textMask]="masks.cpf"
            class="form-control input-validate">
          <app-msg-erro [control]="form.controls.cpf" sempreExibir="true"></app-msg-erro>
        </div>
      </div>
      <div class="col-12 col-lg-4 p-1" *ngIf="formView.cnpj">
        <div class="px-2 pt-2 bg-light rounded">
          <label for="">CNPJ</label>
          <input type="text" [formControl]="form.controls.cnpj" [textMask]="masks.cnpj"
            class="form-control input-validate">
          <app-msg-erro [control]="form.controls.cnpj" sempreExibir="true"></app-msg-erro>
        </div>
      </div>
      <div class="col-12 col-lg-4 p-1" *ngIf="formView.uf">
        <div class="px-2 pt-2 bg-light mb-3 rounded">
          <label for="">UF</label>
          <select class="form-control input-validate" [formControl]="form.controls.uf">
            <option *ngFor="let o of ufOptions" [value]="o.value">{{ o.label }}</option>
          </select>
          <app-msg-erro [control]="form.controls.uf" sempreExibir="true"></app-msg-erro>
        </div>
      </div>

    </ng-container>

    <ng-container *ngIf="(ufOpcional || ufObrigatorio) && !formView.uf">
      <div class="col-lg-8 col-xl-4 flex-grow p-1">
        <div class="px-2 pt-2 bg-light mb-0 rounded">
          <label for="">UF</label>
          <select class="form-control input-validate" [formControl]="form.controls.uf">
            <option *ngFor="let o of ufOptions" [value]="o.value">{{ o.label }}</option>
          </select>
          <app-msg-erro [control]="form.controls.uf" sempreExibir="true"></app-msg-erro>
        </div>
      </div>
    </ng-container>
    <ng-container *ngIf="ufOpcional && !ufObrigatorio">
      <div class="col-12 col-lg-4 p-2">
        <div class="px-2 pt-2 mb-0">
          <p>Para uma melhor entrega da consulta selecionada indicamos, como campo opcional, que seja fornecida a UF de emplacamento do veículo.</p>
        </div>
      </div>
    </ng-container>

  <div class="card-footer d-flex col-12 justify-content-end border-top border-silver bg-white">
    <button [disabled]="form.invalid" (click)="formSubmit()" class="btn btn-lg btn-primary btn-icon px-5">
      <i class="mdi mdi-magnify"></i>
      <span>Realizar consulta</span>
    </button>
  </div>

</div>
